import script from "./ScmPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ScmPage.vue?vue&type=script&setup=true&lang=js"

import "./ScmPage.vue?vue&type=style&index=0&id=78903ec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78903ec9"]])

export default __exports__